<template>
  <div class="block">
    <div class="title">
      <img src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
      <span>限量试玩</span>
      <img class="horizon-reverse" src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
    </div>

    <div class="task row" v-for="(task, index) in running" :key="index" @click="start(task, index)">
      <img :src="task.icon" alt="">
      <span class="desc" v-if="task.user_doing === 1">进行中…</span>
      <span class="desc" v-else-if="task.remain_num > 100">还有 100+ 份</span>
      <span class="desc" v-else-if="task.remain_num > 0">还有 {{task.remain_num}} 份</span>
      <span class="desc disabled" v-else>已抢完</span>
      <span class="unit" :class="{'disabled': task.user_doing !== 1 && task.remain_num <= 0}">元奖励</span>
      <span class="reward" :class="{'disabled': task.user_doing !== 1 && task.remain_num <= 0}">{{task.reward}}</span>
    </div>

    <div class="task row empty" v-if="running.length === 0">
      <img src="//cdn.hongbaoxd.com/images/5782feea5e3a1a882082af4560ba07d3.png" alt="">
      <span class="desc">暂无试玩</span>
    </div>

    <InstallDialog ref="install" />
  </div>
</template>
<style lang='scss' scoped>
  @import 'block';
</style>
<script>
  import { mapState, mapActions } from 'vuex'
  import NoIdentifyDialog from './popups/NoIdentifyDialog'
  import InstallDialog from './popups/InstallDialog'
  import { $toast, $loading } from '@/views/common/Loading.js'
  import { URI_APPTASK_START } from '@/store/modules/dashboard/type'
  export default {
    components: {
      NoIdentifyDialog,
      InstallDialog
    },
    computed: {
      ...mapState({
        running: state => state.dashboard.taskInfo.running,
        pop_bind_cert: state => state.dashboard.taskInfo.pop_bind_cert
      })
    },
    methods: {
      ...mapActions({
        taskStatus: URI_APPTASK_START
      }),
      start (task, index) {
        const hasUnderwayTask = this.running[0].user_doing
        if (hasUnderwayTask === 1) {
          if (index === 0) {
            $router.push('/detail/' + task.id)
          } else {
            $toast.show('请先完成当前进行中的任务', 2000)
          }
        } else {
          // if (this.pop_bind_cert) {
          //   return this.$refs.install.show()
          // }
          this.apptaskStart(task.id)
        }
      },
      // 抢任务
      apptaskStart (id) {
        let delay = 500
        let task_id = id
        let starting = false
        const timeout = (duration) => {
          return new Promise((resolve) => {
            setTimeout(resolve, duration || 0)
          })
        }
        const startTask = (task_id, delay) => {
          if (!starting) {
            $loading.show()
            starting = true
          }
          //  任务轮询
          timeout(delay).then(() => {
            return this.taskStatus({
              tid: task_id
            }).then(res => res.data)
              .then((data) => {
                let { type, message } = data.payload
                delay = 500
                if (type === 1) {
                  // 排队中
                  starting = false
                  startTask(task_id, delay)
                } else if (type === 2) {
                  // 进行中
                  setTimeout(() => {
                    $toast.show('已抢到，红包马上到手', 1000)
                  }, 500)
                  setTimeout(() => {
                    $router.push('/detail/' + task_id)
                  }, 1500)
                } else if (type === 3 && message === '无法开始任务') {
                  setTimeout(() => {
                    $toast.show('无法开始任务', 1000)
                  }, 500)
                  setTimeout(() => {
                    location.reload()
                  }, 1500)
                } else if (type === 4 && message === '暂时无法开始任务，请稍后再试') {
                  starting = false
                  startTask(task_id, delay)
                } else if (type === 4 && message === '没有剩余') {
                  setTimeout(() => {
                    $toast.show('任务已抢完，快去抢其他任务', 1000)
                  }, 500)
                  setTimeout(() => {
                    location.reload()
                  }, 1500)
                } else {
                  $toast.show(message)
                }
              })
          })
        }
        startTask(task_id, delay)
      }
    }
  }
</script>
